<template>
  <!--
      作者：kmdshop
      修改时间：2024-03-15
      描述：车辆风险管控-编辑风险
    -->
    <el-dialog
    title="风险管控详情"
    :visible.sync="dialogVisible"
    width="900px"
    @close="dialogFormVisible"
  >
    <div class="risk-detail">
      <!-- 基础信息 -->
      <el-card class="mb20" shadow="never">
        <div slot="header">
          <span class="card-title">基础信息</span>
        </div>
        <el-descriptions :column="2" border size="medium">
          <el-descriptions-item label="风险名称">
            {{ form.name || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="年份">
            {{ form.year || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="责任部门">
            {{ form.depart_name || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="主要负责人">
            {{ form.responsible_name || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="当前状态">
            <el-tag :type="getStatusTag(form.status)">
              {{ getStatusText(form.status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            {{ form.create_time || '--' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-card>

      <!-- 风险评价 -->
      <el-card class="mb20" shadow="never">
        <div slot="header">
          <span class="card-title">风险评价</span>
        </div>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="辨识范围">
            {{ form.bs_con || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="事故类型">
            {{ form.risk_type_names || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="风险描述">
            {{ form.fx_con || '--' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-card>

      <!-- 风险详细清单 -->
      <el-card class="mb20" shadow="never" v-if="form.control_detail && form.control_detail.length">
        <div slot="header">
          <span class="card-title">风险详细清单</span>
        </div>
        <el-table
          :data="form.control_detail"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column prop="scope_identify_name" label="识别范围" width="120"></el-table-column>
          <el-table-column prop="risk_target" label="风险路段/个体" width="150"></el-table-column>
          <el-table-column prop="description" label="详细描述"></el-table-column>
        </el-table>
      </el-card>

      <!-- 底部按钮 -->
      <div class="dialog-footer" style="text-align: center; padding-top: 20px;">
        <el-button @click="dialogFormVisible" size="medium">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Risk_controlApi from '@/api/risk_control.js';
import AfuncApi from '@/api/afunc.js';

export default {
  data() {
    return {
      // 用于触发部门人员加载的延迟计时器
      loadUserTimer: null,
      /*form表单数据*/
      form: {
        name: '',
        year: new Date().getFullYear().toString(),
        ma_depart_id: '',
        ma_employee_id: '',
        bs_con: '',
        risk_type_id: [],
        fx_con: '',
        control_detail: [],
        attachments: [],
        status: 0
      }
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    if (this.risk_control_id) {
      this.getDetail();
    }
  },
  props: ["open_add", "risk_control_id"],
  watch: {
    'form.ma_depart_id': {
      handler(newVal) {
        if (newVal) {
          // 清除之前的计时器
          if (this.loadUserTimer) {
            clearTimeout(this.loadUserTimer);
          }
          // 延迟100ms执行，避免频繁请求
          this.loadUserTimer = setTimeout(() => {
            this.handleDeptChange(2, newVal);
          }, 100);
        }
      }
    }
  },
  methods: {
    getStatusTag(status) {
      // 统一处理状态值，确保匹配
      const statusStr = status.toString() || '';
      
      const statusMap = {
        '0': 'warning',     // 识别中
        '1': 'primary',     // 待归档
        '2': 'success',     // 已归档
      };
      
      return statusMap[statusStr] || 'info';
    },

    getStatusText(status) {
      // 统一处理状态值
      const statusStr = status.toString() || '';
      
      const statusTextMap = {
        '0': '识别中',
        '1': '待归档',
        '2': '已归档',
      };
      
      return statusTextMap[statusStr] || '未知';
    },
    async handleDeptChange(type, deptId) {
      const response = await AfuncApi.call({
        model: 'ma_employee',
        action: 'getList',
        deptId: deptId
      });
      if (response.code === 1 && response.data.list) {
        this.departUser = response.data.list || [];
      }
    },
    
    // 获取详情
    getDetail() {
      let self = this;
      Risk_controlApi.detail({ risk_control_id: self.risk_control_id,type:1 }, true)
        .then(res => {
          const data = res.data;
          
          // 处理风险类型ID
          let riskTypeIds = [];
          if (data.risk_type_id) {
            if (typeof data.risk_type_id === 'string') {
              riskTypeIds = data.risk_type_id.split(',').map(id => id.trim());
            } else if (Array.isArray(data.risk_type_id)) {
              riskTypeIds = data.risk_type_id;
            }
          }
          
          self.form = {
            name: data.name || '',
            year: data.year || new Date().getFullYear().toString(),
            depart_name: data.depart_name || '',
            responsible_name: data.responsible_name || '',
            bs_con: data.bs_con || '',
            risk_type_names: data.risk_type_names,
            fx_con: data.fx_con || '',
            control_detail: data.control_detail || [],  // 直接使用后端返回的数据
            create_time: data.create_time || [],
            status: data.status
          };
        })
        .catch(error => {
          console.error('获取详情失败:', error);
          self.$message.error('获取风险详情失败');
        });
    },
    
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    }
  }
};
</script>

<style scoped>
.mb20 {
  margin-bottom: 20px;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
}

.mr5 {
  margin-right: 5px;
}

.mb5 {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/risk_control/index/part/detail.vue